import Vue from 'vue'
import Vuex from 'vuex'
// import axios from 'axios' // remove comment if yu needed
import Crud from '../crud'
import Catalogs from '../catalogs'
const model = (payload) => ({
  id: payload.id,
  name: payload.name,
  email: payload.email,
  password: payload.password,
  role: payload.role,
  branch_id: payload.branch_id
})
var crud = new Crud('Users', model)
var catalogs = new Catalogs()

Vue.use(Vuex)

const state = {
  ...crud.state,
  ...catalogs.state,
  catalog: {},
  users: []
}

const mutations = {
  ...crud.mutations,
  ...catalogs.mutations
}

const actions = {
  ...crud.actions,
  ...catalogs.actions
}

const getters = {
  ...crud.getters,
  ...catalogs.getters,
  users: state => state.users
}

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters
}
